import { create } from 'zustand';
import { createSelectionSlice, SelectionSlice } from './map/selectionSlice';
import { devtools } from 'zustand/middleware';
import { createLayerSlice, LayerSlice } from './map/layerSlice';
import {
  createInteractionSlice,
  InteractionSlice,
} from './map/interactionSlice';
import { createRedlineSlice, RedlineSlice } from './map/redlineSlice';
import { createUISlice, UISlice } from './map/uiSlice';
import { SystemLayerKey } from '@packages/database/types';
import {
  CorrectionOverlaySlice,
  createCorrectionOverlaySlice,
} from './map/correctionOverlaySlice';

export type MapState = LayerSlice &
  InteractionSlice &
  SelectionSlice &
  RedlineSlice &
  UISlice &
  CorrectionOverlaySlice;

export const useMapStore = create<MapState>()(
  devtools(
    (...a) => ({
      ...createLayerSlice(...a),
      ...createInteractionSlice(...a),
      ...createSelectionSlice(...a),
      ...createRedlineSlice(...a),
      ...createUISlice(...a),
      ...createCorrectionOverlaySlice(...a),
    }),
    { name: 'MapStore' },
  ),
);

// ─── Selectors ────────────────────────────────────────────────────────────────

export const useVisibleLayers = () =>
  useMapStore((s) => s.layers.filter((l) => l.isVisible));

export const useLayerById = (id: string) =>
  useMapStore((s) => s.layers.find((l) => l.id === id));

export const useLayerByKey = (key: SystemLayerKey | string) =>
  useMapStore((s) => s.layers.find((l) => l.key === key));

export const useLayerByName = (name: string) =>
  useMapStore((s) => s.layers.find((l) => l.displayName === name));

export type {
  MapInteractionMode,
  RedlineTool,
  MapLayerTypes,
  BasemapType,
  SelectionCandidate,
  MapMarkerLocation,
  ProjectAreaSelection,
  ProjectAreaFeature,
} from './map/types';

export { NO_POPUP_TOOLS, NO_EDIT_TOOLS } from './map/types';
